export interface Notification {
  id: string;
  title: string;
  message: string;
  timestamp: number;
  type: NotificationType;
  isRead: boolean;
  userId?: string;
  user_role?: 'traveller' | 'sender';
  relatedEntityId?: string;
  data?: Record<string, unknown>;
}

export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  ORDER = 'order',
  MESSAGE = 'message',
  TEXT = 'text',
  CHAT_MESSAGE = 'chat_message',
  CHAT_ROOM_CREATED = 'chat_room_created',
  GROUP_CHAT_ROOM_CREATED = 'group_chat_room_created',
  ORDER_GROUP_CHAT = 'order_group_chat',
  SYSTEM = 'system',
  SHIPMENT_OFFER_REQUEST = 'shipment_offer_request',
  OFFER_REQUEST_APPROVED = 'offer_request_approved',
  OFFER_REQUEST_REJECTED = 'offer_request_rejected',
  SHIPMENT_OFFER_APPROVED = 'shipment_offer_approved',
  SHIPMENT_OFFER_REJECTED = 'shipment_offer_rejected',
  SHIPMENT_OFFER_WITHDRAWN = 'shipment_offer_withdrawn',
  EDIT_CART_REQUEST = 'edit_cart_request',
  KYC_VERIFICATION = 'kyc_verification',
  ORDER_UNDER_REVIEW = 'order_under_review',
  PAYONEER_ONBOARDING = 'payoneer_onboarding',
  PAYOUT_REQUEST = 'payout_request',
  PASSWORD_CHANGED = 'password_changed',
  ACCOUNT_DELETED = 'account_deleted',
  OFFER_EXPIRY_REMINDER = 'offer_expiry_reminder',
  OFFER_EXPIRED = 'offer_expired',
}

export interface NotificationAction {
  notificationId: string;
  action: 'accept' | 'reject' | 'okay' | 'approve' | 'decline';
  timestamp: number;
}

// SignalR Notification from backend
export interface SignalRNotification {
  user_id: string;
  type: NotificationType;
  title: string;
  message: string;
  user_role?: 'traveller' | 'sender';
  data?: {
    type?: string;
    order_code?: string;
    shipment_id?: number;
    itinerary_id?: number;
    itineraryId?: string;
    shipmentId?: string;
    [key: string]: unknown;
  };
}

export type NormalizedChatMessage = {
  id: string;
  chatRoomId: string;
  senderId: string;
  sender?: {
    id: string;
    full_name: string;
    profile_image?: string;
  };
  message: string;
  messageType: string;
  createdAt: string;
  source: 'signalr';
};
